import { Link } from "react-router-dom";
import { BrandMark } from "../design/BrandMark";

import { StatusChip } from "../design/StatusChip";
import type { Tone } from "../design/tone";

// ---------------------------------------------------------------------------
// The screen that says what went wrong, and what to do about it.
//
// Every dead end in the application ends up here: not found, no access, API
// unreachable. One screen rather than four near-identical ones, because four
// would eventually disagree about the tone of the same condition — and the tone
// IS the message. "We cannot reach the service" is amber, a thing that will
// probably fix itself; "your account is attached to no organisation" is a state
// somebody has to act on.
// ---------------------------------------------------------------------------

export function Message({
  tone,
  status,
  title,
  children,
  action,
}: {
  tone: Tone;
  /** The words on the chip. Never the colour on its own. */
  status: string;
  title: string;
  children?: React.ReactNode;
  action?: { label: string; to: string };
}) {
  return (
    <main className="centre-page">
      <BrandMark />
      <div className="centre-card">
        <StatusChip tone={tone} label={status} />
        <h1>{title}</h1>
        {children}
        {action ? (
          <Link className="btn btn-block" to={action.to}>
            {action.label}
          </Link>
        ) : null}
      </div>
    </main>
  );
}
